import { render, staticRenderFns } from "./DesignationList.vue?vue&type=template&id=752f66c4&scoped=true&"
import script from "./DesignationList.vue?vue&type=script&lang=js&"
export * from "./DesignationList.vue?vue&type=script&lang=js&"
import style0 from "./DesignationList.vue?vue&type=style&index=0&id=752f66c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f66c4",
  null
  
)

export default component.exports